import React, { useEffect, useRef, useState } from "react";
import { LANGUAGES, useI18n } from "../i18n";
import "./language-selector.css";

export const LanguageSelector = ({ variant = "header", className = "" }) => {
  const { lang, setLang } = useI18n();
  const [open, setOpen] = useState(false);
  const ref = useRef(null);
  const current = LANGUAGES.find((l) => lang?.startsWith(l.code)) || LANGUAGES[0];

  useEffect(() => {
    const onDoc = (e) => { if (ref.current && !ref.current.contains(e.target)) setOpen(false); };
    document.addEventListener("mousedown", onDoc);
    return () => document.removeEventListener("mousedown", onDoc);
  }, []);

  const pick = (code) => { setLang(code); setOpen(false); };
  const compact = variant === "header";

  return (
    <div ref={ref} className={`hm-lang ${compact ? "hm-lang--compact" : "hm-lang--wide"} ${className}`} data-testid="language-selector">
      <button type="button" className="hm-lang__trigger" data-testid="language-trigger" aria-haspopup="listbox" aria-expanded={open} onClick={() => setOpen((o) => !o)}>
        {compact ? (<span className="hm-lang__flag" aria-label={current.label}>{current.flag}</span>) : (<><span className="hm-lang__flag">{current.flag}</span><span className="hm-lang__label">{current.label}</span></>)}
        <svg className={`hm-lang__chev ${open ? "is-open" : ""}`} width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.4" strokeLinecap="round" strokeLinejoin="round"><polyline points="6 9 12 15 18 9" /></svg>
      </button>
      {open && (
        <ul className="hm-lang__menu" role="listbox" data-testid="language-menu">
          {LANGUAGES.map((l) => (
            <li key={l.code} role="option" aria-selected={l.code === current.code}>
              <button type="button" className={`hm-lang__item ${l.code === current.code ? "is-active" : ""}`} data-testid={`language-option-${l.code}`} onClick={() => pick(l.code)}>
                <span className="hm-lang__flag">{l.flag}</span>
                <span className="hm-lang__label">{l.label}</span>
                {l.code === current.code && <span className="hm-lang__tick">✓</span>}
              </button>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};

export default LanguageSelector;
